var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('action-tile',{attrs:{"image":"my-documents.svg","max-image-width":"200px","title":"my-documents.page-title"},on:{"click":_vm.navigateToMyDocuments}})
}
var staticRenderFns = []

export { render, staticRenderFns }